var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#062C49",
    d: "M9.304 9.812c-.95.19-2.128-.532-.76-2.66s3.864-2.153 4.94-1.9c1.393.443 3.877 2.128 2.66 5.32c-.607 1.064-1.14 1.33-1.33 1.33c2.496.665 2.595 3.85.76 5.32c-1.144.915-2.862 1.03-4.085-.053c-.371.883-1.028 1.383-2.185 1.383c-2.917 0-2.66-2.85-1.14-2.85c.686 0 .76.95.76 1.52c0 .456 1.15.76 1.339-.95c.054-.752.05-1.49.048-2.212c-.009-2.32.165-4.47 2.033-6.338c.731-.731 1.33-.38.95 0c-.443.499-1.129 1.957-1.293 4.147c.365-.056 1.083-.181 1.484-.347c1.998-.828 1.52-4.75-.38-5.32s-3.23.76-3.42.95c-.11.11-.207.217-.19.38c0 0 1.52 1.71-.19 2.28m2.66 2.956v.084c0 1.366-.03 2.55-.224 3.48c.569.552 1.313.627 1.745.51c2.793-.931 1.57-5.33-1.52-4.074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBob);
export default __webpack_public_path__ + "static/media/bob.a4f22413f86fc646715f1abe2675cbd5.svg";
export { ForwardRef as ReactComponent };